import { memo } from 'react';

import CreditCardIconSVG from '@/assets/credit-card-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const ICreditCardIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={CreditCardIconSVG} {...props} />;

export const CreditCardIcon = memo(ICreditCardIcon) as typeof ICreditCardIcon;
